import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';

import './modal.css'
const ReactBootstrapModal = ({
    formFooter,
    showModalRecovery,
    showModalUnlockUser,
    toggleModal,
    text,
    textButton,
    submitHandler,
    onResetPassword,
    reg,
    validationErrors

}) => {


    return (
        <Modal
            show={showModalRecovery || showModalUnlockUser}
            onHide={toggleModal}
            dialogClassName='modal-dialog-centered'
        >
            <Modal.Header closeButton>
                <Modal.Title>{text}</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <Form onSubmit={submitHandler(onResetPassword)}>

                    <FloatingLabel
                        controlId="floatingInput"
                        label="Email o DNI"
                        className="mb-3"
                    >
                        <Form.Control
                            className={`form-control form-control-height ${validationErrors['email'] ? 'inError' : ''}`}
                            type="text"
                            name="email"
                            placeholder="name@example.com"
                            {...reg('email', { required: 'password is required', })}
                        />
                    </FloatingLabel>

                    <Modal.Footer className='footerClass'>
                        <Button
                            className='button'
                            variant="secondary"
                            onClick={validationErrors['email'] ? null : toggleModal}
                            type="submit">
                            {textButton}
                        </Button>

                        {formFooter}
                    </Modal.Footer>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default ReactBootstrapModal;
